var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.css(),style:(("background-image: url(" + _vm.url + ");")),attrs:{"href":_vm.url,"target":"_blank","rel":"noopener noreferrer"}})}
var staticRenderFns = []

export { render, staticRenderFns }